import { useMutation } from 'react-query';
import { MutationConfig, queryClient } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


export const createModelType = ( {data} : {data: IPostNewModelType | {}}): Promise<string> => {
  return axiosDefaultApi.post(`/api/ModelTypes/InsertModelType`, data);
};

type QueryFnType = typeof createModelType;

type UseCreateModelTypeOptions = {
  data: IPostNewModelType | {};
  config?: MutationConfig<QueryFnType>;
};

export const useCreateModelType = ({ config }: UseCreateModelTypeOptions) => {
    const {addNotification, setIsNotificationVisible} = useNotification();
    return useMutation({
        onError: (error: any) => {
            addNotification(`Υπήρξε κάποιο πρόβλημα στην δημιουργία του Είδους Συσκευής.`, 500);
            console.error('Couldnt create new ModelType', error);
            setIsNotificationVisible(true)
          },
          onSuccess: () => {
            queryClient.invalidateQueries(["getAllModelTypes"])
            addNotification(`Δημιουργήθηκε Νέο Είδος Συσκευής.`, 200);
            setIsNotificationVisible(true)  
          },
        ...config,
        mutationFn: createModelType,
    })
}